import { render, staticRenderFns } from "./Classificar.vue?vue&type=template&id=82842278"
import script from "./Classificar.vue?vue&type=script&lang=js"
export * from "./Classificar.vue?vue&type=script&lang=js"
import style0 from "./Classificar.vue?vue&type=style&index=0&id=82842278&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports